import HtmlTrans from 'components/shared/HtmlTrans';
import { Heading2 } from 'components/shared/Typography';
import { useRouter } from 'next/router';
import { Element } from 'react-scroll';
import Form from './form/Form';
import { useTalentEngineFooter } from './TalentEngineFooter.hooks';
import {
  StyledContainer,
  StyledHeader,
  StyledWrapper
} from './TalentEngineFooter.styled';

type FooterProps = {
  isLight?: boolean;
};

const TalentEngineFooter: React.FC<FooterProps> = ({ isLight }) => {
  const { t, onSubmit, formMethods, isFormFilled, onFormFieldFocus } =
    useTalentEngineFooter();
  const { locale } = useRouter();

  return (
    <StyledWrapper>
      <Element name="talentEngineForm" id="talentEngineForm">
        <StyledContainer>
          <StyledHeader>
            <Heading2 editorial>
              {t('talent-engine-landing.form.title')}
            </Heading2>
            <p>
              <HtmlTrans
                ns="talent-engine-landing-v3"
                i18nKey="talent-engine-landing.form.desc"
              />
            </p>
          </StyledHeader>

          <Form />
        </StyledContainer>
      </Element>
    </StyledWrapper>
  );
};

export default TalentEngineFooter;
